import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OccupancyMonthlyReportResponseV4Schema } from "../response/OccupancyMonthlyReportResponseV4";
import { OccupancyMonthlyReportFilterV4Type } from "../schema/OccupancyMonthlyReportFilterSchemaV4";

const API_VERSION = 'v4';

interface OccupancyMonthlyReportV4Props {
    filter?: OccupancyMonthlyReportFilterV4Type;
    type: string | null;
    group_by?: string;
}

const useOccupancyMonthlyReportV4 = (params: OccupancyMonthlyReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-occupancy-monthly',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.group_by
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/group-report-occupancy-monthly`, {
                    params: {
                        filter: {
                            ...params.filter,
                        },
                        group_by: params.group_by,
                    },
                });

                const validationResult = OccupancyMonthlyReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Occupancy Monthly report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Occupancy Monthly report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_ids && !!params.filter.start_date && !!params.filter.end_date && params.type === "occupancy_report" && !!params.group_by,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useOccupancyMonthlyReportV4;